import { Editor } from "@monaco-editor/react";
import { Card } from "antd";

const DefectTreeEditor = ({
  height = "50vh",
  tree,
  onUpdate,
  loading = false,
}) => {
  return (
    <Card loading={loading}>
      <Editor
        onChange={onUpdate}
        defaultValue={JSON.stringify(tree, null, 2)}
        defaultLanguage="json"
        height={height}
      />
    </Card>
  );
};

export default DefectTreeEditor;
